// Exports
export default {
	"stubWrapper": "stubWrapper_iTQFa"
};
